module.exports = function(start, end, custom, requires, defaultValue) {
  var colorList = ['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4'];

  var opt = {
    label: 'Farbe',
    required: true,
    type: 'select',
    defaultValue: (typeof defaultValue == undefined ? null : defaultValue),
    options: []
  };

  if (typeof start == 'object' && start != null) {
    custom = start;
  } else {
    if (typeof start == 'undefined' || start == null) {
      start = colorList[0];
    }
    if (typeof end == 'undefined' || end == null) {
      end = colorList[colorList.length - 1];
    }

    var add = false;
    colorList.forEach(function(c) {
      if (c == start) {
        add = true;
      }
      if (add) {
        opt.options.push({
          value: c,
          label: c
        });
      }
      if (c == end) {
        add = false;
      }
    });
  }

  if (typeof custom != 'undefined' && typeof custom == 'object' && custom != null) {
    custom.forEach(function(c) {
      opt.options.push({
        value: c,
        label: c
      });
    });
  }

  if (typeof requires == 'object' || requires != null) {
    opt.requires = requires;
  }

  return opt;
}
